import Weekly2026Page from "./Weekly2026Page";
export default function LatestWeekly() {
  return <Weekly2026Page latest="true" list="weekly_2026" />;
}
